import axios from "axios";
import qs from "qs";
import CryptoJS from 'crypto-js'
// const preUrl = "https://www.gzsxjsbwg.cn/guanwangApi";
axios.defaults.baseURL = window.Internet.baseURL;
// axios.defaults.baseURL = '/api';

/**
 * AES加密 ：字符串 key iv  返回base64
 */
export function Encrypt(word, keyStr, ivStr) {
  if (!word) return
  let key = CryptoJS.enc.Utf8.parse("63ezac68cf173c8c");
  let iv = CryptoJS.enc.Utf8.parse("63eeac13cf014c8c");
  if (keyStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr);
    iv = CryptoJS.enc.Utf8.parse(ivStr);
  }
  let srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });
  // return  word
  return encodeURIComponent(CryptoJS.enc.Base64.stringify(encrypted.ciphertext));
}

export function EncryptData(params) {
  for (var i in params) {
    if (typeof params[i] != 'boolean.' && i != 'pageNum' && i != 'pageSize') {
      params[i] = Encrypt(params[i])
    }
  }
  return params
}

//查询文章列表
export const articleListApi = params => {
  params = EncryptData(params)
  return axios
    .get(`/api/article/list?` + qs.stringify(params))
    .then(res => res.data);
};

// 获取文章详细信息
export const articleDetailApi = params => {
  return axios.get(`/api/article?articleId=${Encrypt(params.articleId)}`).then(res => res.data);
};

// 文章附件列表
export const accessoryListApi = params => {
  params = EncryptData(params)

  return axios
    .get(`/api/accessory/list?` + qs.stringify(params))
    .then(res => res.data);
};

// 获取文章附件详细信息
export const accessoryDetailApi = params => {
  return axios
    .get(`/api/accessory?accessoryId=${Encrypt(params.accessoryId)}`)
    .then(res => res.data);
};

// 网站访问量
export const configKeyApi = params => {
  return axios
    .get(`/api/config/configKey/${Encrypt('page_view')}`)
    .then(res => res.data);
};

// 获取前端菜单下拉树列表
export const menuTreeApi = () => {
  return axios.get(`/api/uimenu/treeselect`).then(res => res.data);
};

// 查询前端菜单列表
export const menuListApi = params => {
  params = EncryptData(params)
  return axios
    .get(`/api/uimenu/list?` + qs.stringify(params))
    .then(res => res.data);
};
// 获取人员管理
export const personnelApi = params => {
  params = EncryptData(params)
  return axios
    .get(`/api/personnel/list?` + qs.stringify(params))
    .then(res => res.data);
};
// 获取服务指南详细信息
export const directoryApi = params => {
  return axios
    .get(`/api/directory?serviceDirectoryId=${Encrypt(params.serviceDirectoryId)}`)
    .then(res => res.data);
};

// 获取观众问卷调查
export const optionsApi = params => {
  params = EncryptData(params)
  return axios.get(`/api/topic/list?` + qs.stringify(params)).then(res => res.data);
};

// 根据字典类型查询字典数据信息
export const dictDataApi = params => {
  return axios
    .get(`/api/dict/data/type?dictType=${Encrypt(params.dictType)}`)
    .then(res => res.data);
};

// 新增问卷调查
export const newQuestionApi = params => {
  // params = EncryptData(params)
  return axios.post(`/api/info`, params).then(res => res.data);
};

//banner获取
export const bannerApi = params => {
  params = EncryptData(params)
  return axios
    .get(`/api/banner/list?` + qs.stringify(params))
    .then(res => res.data);
};

// 首页典藏
export const getWenGenApi = () => {
  return axios.get(`/api/homePage/getWenGen`).then(res => res.data);
};
// 获取友情链接
export const getBlogrollApi = () => {
  return axios.get(`/api/blogroll/list`).then(res => res.data);
};
// 获取网站访问量
export const getPageViewApi = () => {
  return axios.get(`/api/config/configKey/page_view`).then(res => res.data);
};
// 下载接口
// export const downloadApi = (params) => {
// 	return axios({
// 		method: 'get',
// 		url: "/common/downloadImage?" + "fileName=" + params,
// 		responseType: 'blob',
// 	})
// };
// 通用下载方法
// export function download(fileName) {
//   let str = preUrl + fileName
//   // }
//   console.log('str', str)
//   // window.open(str);
//   window.location.href = str;
// }
// export function download(sourceUrl,fileName) {
//   const link = document.createElement('a');
//   link.style.display = 'none';
//   // 设置下载地址
//   link.setAttribute('href', sourceUrl);
//   // 设置文件名
//   link.setAttribute('download', fileName);
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// }

export function download(data, name) {
  axios({
    method: "get",
    url: "/common/download/resource?" + "name=" + data,
    responseType: "blob"
  })
    .then(res => {
      try {
        const blobUrl = window.URL.createObjectURL(res.data);
        const a = document.createElement("a");
        a.style.display = "none";
        a.download = name;
        a.href = blobUrl;
        a.click();
      } catch (e) {
        console.log(e);
      }
    })
    .catch(error => {
      console.log(error);
    });
}
// 封装下载图片
export default function exportMethod(data, name) {
  axios({
    method: "get",
    url: "/common/downloadImage?" + "fileName=" + data,
    responseType: "blob"
  })
    .then(res => {
      try {
        const blobUrl = window.URL.createObjectURL(res);
        const a = document.createElement("a");
        a.style.display = "none";
        a.download = name;
        a.href = blobUrl;
        a.click();
      } catch (e) {
        console.log(e);
      }
    })
    .catch(error => {
      console.log(error);
    });
}

// 获取前端菜单详细信息
export const getOneMenuInfo = uiMenuId => {
  return axios.get(`/api/uimenu?uiMenuId=${Encrypt(uiMenuId)}`).then(res => res.data);
};
//
export const getDirectoryInfo = () => {

  return axios.get(`/api/directory/list`).then(res => res.data);
};
/**查询相册图片数量 */
export const getPhotoNum = uiMenuId => {
  return new Promise(function (resolve, reject) {
    axios.get(`/api/image/list?articleId=${Encrypt(uiMenuId)}`).then(res => {
      if (res.data.code == 200) {
        resolve(res.data);
      } else {
        reject("出错了");
      }
    });
  });
};



// WEBPACK FOOTER //
// ./src/assets/js/api.js